import Button from 'react-bootstrap/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useEffect } from 'react'
import ApiCaller from '../../constants/ApiCaller'
import urls from '../../constants/apiurl'
import { updateLoading } from '../../../redux/features/common/commonSlice'
import { useState } from 'react'
import { showDangerToast } from '../../constants/toaster'
import { useDispatch, useSelector } from "react-redux"

export const AddSubAdmin = props => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.userData);
  const [isValidEmail, setIsValidEmail] = useState(true)
  const [isValidMobile, setIsValidMobile] = useState(true)
  const [isValidFirstName, setIsValidFirstName] = useState(true)
  const [isValidLastName, setIsValidLastName] = useState(true)
  const [submitted, setSubmitted] = useState(false);
  const [countryCodeList, setCountryCodeList] = useState([{
    value: "",
    label: "Select Country"
  }])
  const [countryDetails, setCountryDetails] = useState({
    value: "",
    label: "Select Country"
  })


  useEffect(() => {
    if (props?.show) {
      getCountryCodeList()
    }
  }, [props?.show])

  const getCountryCodeList = async () => {
    try {
      dispatch(updateLoading(true))
      let path = urls.countryCodeList
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        let tempArray = []
        response?.data.forEach(element => {
          tempArray.push({
            value: element?.id,
            label: element?.code,
            // ext: element?.code
          })
        });
        setCountryCodeList(tempArray)
        if (tempArray?.length > 0) {
          setCountryDetails(
            tempArray[0]
          )
          props?.setCountryId(tempArray[0]?.value)
        } else {
          setCountryDetails({
            value: "",
            label: '',
            // ext: ''
          })
        }
        // let tempArray = [...countryCodeList]
        // response?.data.forEach(element => {
        //   tempArray.push({
        //     value: element?.id,
        //     label: element?.name,
        //     ext: element?.code
        //   })
        // });
        // setCountryCodeList(tempArray)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleChangeEmail = (e) => {
    const inputValue = e.target.value;
    props.setSubAdminFormData({
      type: 'UPDATE',
      payload: { email: inputValue }
    })
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(inputValue);
    setIsValidEmail(isValid);
  }
  const handleChangeMobile = (e) => {
    const inputValue = e.target.value;
    const numericInput = inputValue.replace(/[^0-9]/g, '').slice(0, 12);
    props.setSubAdminFormData({
      type: 'UPDATE',
      payload: { contactNumber: numericInput }
    })
    if (!inputValue) {
      setIsValidMobile(false)
    } else {
      setIsValidMobile(true)
    }
  }

  const handleSubmit = () => {
    if (
      props?.subAdminFormData.firstName === '' ||
      props?.subAdminFormData.lastName === '' ||
      props?.subAdminFormData.email === '' ||
      props?.subAdminFormData.contactNumber === '' ||
      props?.subAdminFormData?.roleId === '' ||
      countryDetails?.value === ''
    ) {
      setSubmitted(true)
      showDangerToast('Please fill all required fields')
    } else {
      if (!isValidEmail) {
        showDangerToast('Invalid Email')
      } else if (!isValidMobile) {
        showDangerToast('Invalid Mobile')
      } else {
        setSubmitted(false)
        props.onSubmit()
      }
    }
  }

  const handleNameInputChange = (e, inputType) => {
    const value = e.target.value;
    // Check if the input matches the validation criteria
    const isValidInput = /^[a-zA-Z]{2,20}$/.test(value);
    // Update the state based on validation result
    if (inputType === 'firstName') {
      setIsValidFirstName(isValidInput)
    } else if (inputType === 'lastName') {
      setIsValidLastName(isValidInput)
    }
    props.setSubAdminFormData({
      type: 'UPDATE',
      payload: { [inputType]: value }
    })
  };
  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header>
        <Modal.Title id='contained-modal-title-vcenter'>
          {props?.subAdminFormData?.id ? 'Update SubAdmin' : 'Add SubAdmin'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row'>
          <div className='col-md-6'>
            <Form.Group controlId='exampleForm.ControlInput1'>
              <h4>First Name*</h4>
              <Form.Control
                type='text'
                placeholder='Enter First Name'
                value={props.subAdminFormData.firstName}
                onChange={e => handleNameInputChange(e, 'firstName')}
              />
              {props?.subAdminFormData?.firstName === '' && submitted  ? (
                <label className='custom-error-label'>
                  First Name is required*
                </label>
              ) : (
                !isValidFirstName &&  submitted &&(
                  <label className='custom-error-label'>
                    Input must be between 2 and 20 alphabetic characters and cannot contain spaces or special characters.
                  </label>
                )
              )}
            </Form.Group>
          </div>
          <div className='col-md-6'>
            <Form.Group controlId='exampleForm.ControlInput1'>
              <h4>Last Name*</h4>
              <Form.Control
                type='text'
                placeholder='Enter Last Name'
                value={props.subAdminFormData.lastName}
                onChange={e => handleNameInputChange(e, 'lastName')}
              />
              {props?.subAdminFormData?.lastName === '' && submitted ? (
                <label className='custom-error-label'>
                  Last Name is required*
                </label>
              ) : (
                !isValidLastName && submitted && (
                  <label className='custom-error-label'>
                   Input must be between 2 and 20 alphabetic characters and cannot contain spaces or special characters.
                  </label>)
              )}
            </Form.Group>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-md-6'>
            <Form.Group controlId='exampleForm.ControlInput1'>
              <h4>Email*</h4>
              <Form.Control
                type='text'
                placeholder='Enter Email'
                value={props.subAdminFormData.email}
                onChange={handleChangeEmail}
              />
              {props?.subAdminFormData?.email === '' && submitted ? (
                <label className='custom-error-label'>Email is required*</label>
              ) : (
                !isValidEmail && submitted  ? <>
                  <label className='custom-error-label'>Invalid Email*</label>
                </> : <></>
              )}
            </Form.Group>
          </div>
          <div className='col-md-6'>
            <Form.Group controlId='exampleForm.ControlInput1'>
              <h4>Phone No.*</h4>
              <div className='d-flex'>
                <Dropdown
                  options={countryCodeList}
                  onChange={e => {
                    setCountryDetails(e)
                    props?.setCountryId(e?.value)
                  }}
                  value={props?.subAdminFormData.extensionNumber ? props?.subAdminFormData.extensionNumber : countryDetails}
                />
                {countryDetails?.value === '' && submitted ? (
                  <label className='custom-error-label'>Country is required*</label>
                ) : (
                  <></>
                )}
                <Form.Control
                  type='text'
                  placeholder='Enter Phone No.'
                  value={props.subAdminFormData.contactNumber}
                  onChange={handleChangeMobile}
                />
              </div>
              {props?.subAdminFormData?.contactNumber === '' && submitted ? (
                <label className='custom-error-label'>Phone is required*</label>
              ) : (
                !isValidMobile ? <>
                  <label className='custom-error-label'>Invalid Mobile*</label>
                </> : <>
                  {props?.subAdminFormData?.contactNumber && props?.subAdminFormData?.contactNumber.length < 7 && <label className='custom-error-label'>Mobile should be between 7-12 *</label>}

                </>
              )}
            </Form.Group>
          </div>
          <div className='col-md-6 mt-3'>
            <Form.Group controlId='exampleForm.ControlInput1'>
              <h4>Role.*</h4>
              <Dropdown
                options={props?.roleKeyValueData}
                onChange={e =>
                  props.setSubAdminFormData({
                    type: 'UPDATE',
                    payload: { roleId: e.value }
                  })
                }
                value={props?.defaultRoleOption}
                placeholder='Select Role'
              />
              {props?.subAdminFormData?.roleId === '' && submitted ? (
                <label className='custom-error-label'>Role is required*</label>
              ) : (
                <></>
              )}
            </Form.Group>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outlined' onClick={()=>{
          setSubmitted(false)
          props.onHide()
          }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} >Submit</Button>
      </Modal.Footer>
    </Modal>
  )
}
